module.exports = __webpack_public_path__ + "static/Background-mla-3.58ba7522.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Background-mla-3.jpg
// module id = 472
// module chunks = 172546399187757